import React from 'react';
import ContactSalesDialog from '@/components/organisms/ContactSalesDialog';
import { useGlobalRestrictionDialog } from '@/hooks/useGlobalRestrictionDialog';

export const GlobalRestrictionDialog: React.FC = () => {
  const { isOpen, restrictionType, restrictionConfig, onPrimaryAction, onSecondaryAction, closeRestrictionDialog } =
    useGlobalRestrictionDialog();

  const handlePrimaryAction = () => {
    if (onPrimaryAction) {
      onPrimaryAction();
    }
    closeRestrictionDialog();
  };

  const handleSecondaryAction = () => {
    if (onSecondaryAction) {
      onSecondaryAction();
    }
    closeRestrictionDialog();
  };

  return (
    <ContactSalesDialog
      isOpen={isOpen}
      restrictionType={restrictionType}
      heading={restrictionConfig.heading}
      message={restrictionConfig.message}
      primaryActionTitle={restrictionConfig.primaryActionTitle}
      secondaryActionTitle={restrictionConfig.secondaryActionTitle}
      handlePrimaryActionClick={handlePrimaryAction}
      handleSecondaryActionClick={handleSecondaryAction}
    />
  );
};
